import React from 'react';
import { withAlertHandler } from 'entoro-shared';
import Dialog, {
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import { watersRegistration } from '../../apollo';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import RegisterForm from './RegisterForm';
import Slide from 'material-ui/transitions/Slide';

import { withStyles } from 'material-ui/styles';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const styles = {
  appBar: {
    position: 'relative',
    height: '20vh',
    minHeight: '0rem',
  },
  flex: {
    flex: 1,
  },
};

class TTWatersOffer extends React.Component {
  state = {
    showPosition: false,
    showRegister: false,
    showsuitability: false,
    userId: null,
  };

  transition = (props) => {
    return <Slide direction='up' {...props} />;
  };

  handleRegistration = async ({
    firstName,
    lastName,
    email,
    address,
    amount,
    offerId,
  }) => {
    const { client, handleSnackbarError, offer, handleClose } = this.props;

    const { mutate } = client;
    const variables = {
      input: {
        firstName,
        lastName,
        email,
        address,
        amount,
        offerId: offer._id,
      },
    };
    try {
      const { data } = await mutate({
        mutation: watersRegistration,
        variables,
      });

      if (data) {
        handleClose();
        const MySwal = withReactContent(Swal);
        const Toast = MySwal.mixin({
          toast: true,
          position: 'top-right',
          showConfirmButton: false,
          timer: 8000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', MySwal.stopTimer);
            toast.addEventListener('mouseleave', MySwal.resumeTimer);
          },
        });

        Toast.fire({
          icon: 'success',
          title:
            'Your application was successfully,we will be in touch shortly.',
        });
        sessionStorage.setItem(
          'watersUserId',
          data.createWatersInvestorUser._id
        );
        // this.handleSuitability();
      }
    } catch (error) {
      handleSnackbarError(error);
    }
  };
  render() {
    const { data, title, handleClickOpen, handleClose, open } = this.props;

    return (
      <div>
        <button
          onClick={handleClickOpen}
          className='button small w-button'
          style={{ width: 'inherit', marginRight: 10 }}
        >
          {title}
        </button>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>{'Registration'}</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText></DialogContentText>
            <RegisterForm handleRegistration={this.handleRegistration} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default connect()(
  withApollo(withAlertHandler(withStyles(styles)(TTWatersOffer)))
);



// WEBPACK FOOTER //
// ./src/components/TTWaters/index.js